import SectionLandingPage, {
  SectionLandingLink,
} from "components/components/SectionLandingPage/SectionLandingPage";
import React from "react";
import routeConstants from "utils/routeConstants";

const links: SectionLandingLink[] = [
  {
    title: "Rolling system demand",
    to: routeConstants.rollingSystemDemand,
    description:
      "NESO provides an estimate of the Transmission System Demand (or Rolling System Demand) using operational meters. This is derived from " +
      "the total of all Fuel Type categories from the Generation by Fuel Type report.",
  },
  {
    title: "Surplus forecast and margin",
    to: routeConstants.surplusAndMargin,
    description:
      "NESO derives the National Surplus Forecast and Generating Plant Operating Margin reports. Both are presented as daily MW values from 2 " +
      "days to 14 days ahead and weekly MW values for the 2 weeks to 156 weeks ahead.",
  },
  {
    title: "Demand outturn",
    to: routeConstants.demandOutturn,
    description:
      "The Initial Demand Outturn measures the half-hour average MW demand metered by the Transmission Company based on its operational metering. " +
      "Data is updated every 30 minutes and within 15 minutes of the end of the effective Settlement Period.",
  },
  {
    title: "Daily energy transmitted",
    to: routeConstants.dailyEnergyTransmitted,
    description:
      "NESO provides the Initial National Demand Out-Turn Daily (INDOD) data, which is presented on a graph covering a rolling 3-month period.",
  },
  {
    title: "Demand forecast",
    to: routeConstants.demandForecast,
    description:
      "NESO provides demand forecast data as National Demand Forecast and Transmission System Demand Forecast in three different timeframe and " +
      "resolution timescales: Day and day ahead, 2 to 14 days ahead, and 2 to 52 weeks ahead.",
  },
  {
    title: "Indicative peak demand",
    to: routeConstants.indicativeDemandPeak,
    description:
      "The Triad indicative demand peaks are the three settlement periods of highest transmission system demand (excluding interconnectors) within " +
      "a financial year (specifically in the Triad season November to February inclusive).",
  },
  {
    title: "Total load: actual and day-ahead forecast",
    to: routeConstants.totalLoadActualAndDayAhead,
    description:
      "Transmission System Operators calculate and submit the total load per Settlement Period for their control areas. They also calculate and " +
      "submit a day-ahead forecast of the total load per zone.",
  },
  {
    title: "Total load: week-ahead forecast",
    to: routeConstants.totalLoadWeekAhead,
    description:
      "Transmission System Operators shall calculate and submit a week-ahead forecast of the total load for every day of the following week, " +
      "which shall for each day include a maximum and a minimum load value for each bidding zone.",
  },
  {
    title: "Indicated forecasts",
    to: routeConstants.indicatedForecasts,
    description:
      "NESO provides a forward view of auxiliary datasets to provide additional context to generation and demand data. These are currently " +
      "reported as Indicated Margin (MELNGC), Indicated Imbalance (IMBALNGC), Indicated Generation (INDGEN), and Indicated Demand (INDDEM).",
  },
  {
    title: "Restoration region demand forecast",
    to: routeConstants.restorationZoneDemandForecast,
    description:
      "Each day at 09:00, 11:45 and 17:00 London time, NESO creates a forecast peak value for the day-ahead demand effective for the Settlement " +
      "date and Restoration region.",
  },
  {
    title: "Restoration region demand restored",
    to: routeConstants.restorationZoneDemandRestored,
    description:
      "During a system restoration event NESO provides hourly updates to enable tracking of restoration progress in a specific restoration region.",
  },
];

const Demand: React.FC = () => (
  <SectionLandingPage
    title="Demand"
    description={
      <>
        <p>
          The Demand data section provides information on electricity demand
          across Great Britain.
        </p>
        <p>
          This section includes real-time and historical data, including
          forecasts and actual outturns, daily energy transmitted, and peak
          demand indicators. From short-term load forecasts to week-ahead
          outlooks and regional restoration data, it provides a complete view of
          how electricity demand is measured, anticipated, and managed across
          the system.
        </p>
      </>
    }
    links={links}
  />
);

export default Demand;
